import { AxiosRequestConfig } from 'axios';
import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IPersonalWorkload, IPersonalWorkloadCreate, IPosition, IRealEstateClass } from './interfaces';

const BASE_URL = '/calculatorTariff/personalWorkload';

export const getPersonalWorkloadList = (params: IDynamicTableParams): Promise<IPersonalWorkload[]> => {
  return instance()
    .post(`${BASE_URL}/list`, params)
    .then((response) => response.data);
};

export const getPersonalWorkloadAvailableColumns = (): Promise<IAvailableColumnModel[]> => {
  return instance()
    .post(`${BASE_URL}/availableColumns`)
    .then((response) => response.data);
};

export const getPersonalWorkloadAvailableGroupColumns = (): Promise<IAvailableGroupColumnModel[]> => {
  return instance()
    .post(`${BASE_URL}/availableGroupColumns`)
    .then((response) => response.data);
};

export const loadPersonalWorkload = (personalWorkloadId: number): Promise<IPersonalWorkload> => {
  return instance()
    .get<IPersonalWorkload>(`${BASE_URL}/load/${personalWorkloadId}`)
    .then((response) => response.data);
};

export const createPersonalWorkload = (data: IPersonalWorkloadCreate): Promise<void> => {
  return instance()
    .post(`${BASE_URL}/save`, data)
    .then((response) => response.data);
};

export const updatePersonalWorkload = (personalWorkload: IPersonalWorkload): Promise<IPersonalWorkload> => {
  return instance()
    .post<IPersonalWorkload>(`${BASE_URL}/${personalWorkload.personalWorkloadId}/update`, personalWorkload)
    .then((response) => response.data);
};

export const deletePersonalWorkload = (personalWorkloadId: number): Promise<void> => {
  return instance()
    .post(`${BASE_URL}/archive`, { personalWorkloadId })
    .then((response) => response.data);
};

export const recoverPersonalWorkload = (personalWorkloadId: number): Promise<void> => {
  return instance()
    .post(`${BASE_URL}/recover`, { personalWorkloadId })
    .then((response) => response.data);
};

export const getPositionList = (config?: AxiosRequestConfig): Promise<IPosition[]> => {
  return instance()
    .post<IPosition[]>('/dictionary/positions', {}, config)
    .then((response) => response.data);
};

export const getRealEstateClassList = (config?: AxiosRequestConfig): Promise<IRealEstateClass[]> => {
  return instance()
    .get<IRealEstateClass[]>('/calculatorTariff/realEstateClass/search', config)
    .then((response) => response.data);
};
